import { render } from "./CalendarSidebar.vue?vue&type=template&id=a82251b6&scoped=true"
import script from "./CalendarSidebar.vue?vue&type=script&lang=js"
export * from "./CalendarSidebar.vue?vue&type=script&lang=js"

import "./CalendarSidebar.vue?vue&type=style&index=0&id=a82251b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a82251b6"]])

export default __exports__